import { motion, useReducedMotion } from "framer-motion";
import NeptuneTrident from "./NeptuneTrident";
import { NeptuneWordmark } from "./NeptuneMark";

/**
 * Centered Neptune brand lockup for the hero — vertical stack for perfect optical balance.
 *
 *  - Trident sits above the wordmark, both share the same horizontal center.
 *  - Trident has a gentle breathing motion, never rotates.
 *  - No animated light-sweep over the lockup. The shimmer was a 2024 AI-template
 *    cliché; static silver/cyan reads more premium for a payments brand. Trident's
 *    breathing motion + initial fade-in are the only motion on the lockup.
 *  - Respects prefers-reduced-motion.
 */
export default function HeroLogo({ size = 56 }) {
  const reduced = useReducedMotion();
  const tridentSize = Math.round(size * 1.15);
  const wordHeight = Math.round(size * 0.78);

  return (
    <motion.div
      data-testid="hero-logo"
      initial={{ opacity: 0, y: -8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
      className="relative inline-flex flex-col items-center"
      style={{ gap: "10px" }}
    >
      <motion.div
        data-testid="hero-logo-trident"
        animate={reduced ? {} : { y: [0, -3, 0], scale: [1, 1.03, 1] }}
        transition={{ duration: 5, ease: "easeInOut", repeat: Infinity }}
        style={{
          willChange: "transform",
          transform: "translateZ(0)",
          width: "fit-content",
        }}
        className="relative inline-block leading-[0]"
      >
        <NeptuneTrident size={tridentSize} />
      </motion.div>

      <span className="relative inline-block">
        <NeptuneWordmark height={wordHeight} />
      </span>
    </motion.div>
  );
}
